import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as backInter from 'app/auth/auth-data.model';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
  selector: 'previsualizacion',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  eventsSubscription: any
  @Input('idiomas') idiomas: backInter.getIdiomas;
  @Input() actualizaAdicionales: Observable<any>;
  @Input('preguntasTraduccionesAdicionalesFocus') preguntasTraduccionesAdicionalesFocus: backInter.respuestaTraduccionesPreguntasAdicionalesFocus;
  @Input('preguntasAdicionalesFocus') preguntasAdicionalesFocus: backInter.getPreguntasAdiocnalesFocus;

   cargando = false;

  idiomaDefault: backInter.getIdiomaInd;
  textosPreguntasFiltrados: any[] = [];
  totalTextosTraduccion = 0;
  numeroTextosTraduccion: number[] = [];

  idiomasFiltrados: any[] = [];

  primeraSeleccion = false;
  //tipos de pregunta
  idAbierta = 2;
  idSingle = 1;
  idMulti = 6;

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_idiomas.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    // console.log("estos son los idiomas de focu Preview ",this.idiomas);
    this.eventsSubscription = this.actualizaAdicionales.subscribe( (datos) => {
      console.log("entro este visne",datos);
      this.preguntasTraduccionesAdicionalesFocus=datos;
      this.obtieneIdiomas();
    })
    // setTimeout( () => {
    //   this.cargando = false;
    //   this.obtieneIdiomas();
    //   this.limpiaListadoIdiomas();
    //   console.log(this.idiomas);
    // },2000);

    let esperarDatos= setInterval(()=>{
      if (this.idiomas) {
        this.cargando = false;
          this.obtieneIdiomas();
          this.limpiaListadoIdiomas();
          console.log(this.idiomas);
          clearInterval(esperarDatos);
      }

    },0);
  }
  //
  reiniciaVariables(){
    // this.preguntasAdicionales = null;
    this.idiomaDefault = null;
    this.textosPreguntasFiltrados = [];
    this.totalTextosTraduccion = 0;
    this.numeroTextosTraduccion = [];
    this.idiomasFiltrados = [];
  }

  limpiaListadoIdiomas(){
    if(this.idiomas.idiomas.length > 0){
    this.idiomas.idiomas.forEach( (idioma: backInter.getIdiomaInd) => {
        if(idioma.tipoIdioma != "3"){
          this.idiomasFiltrados.push(idioma);
          console.log(this.idiomasFiltrados);
}

      });
    }
  }

  obtieneIdiomas(){
    console.log(this.idiomas);

    if(this.idiomas.idiomas.length > 0){
      this.idiomas.idiomas.forEach( (idioma: backInter.getIdiomaInd) => {
        if(idioma.tipoIdioma == "1"){
          this.idiomaDefault = idioma;
        }

      });
    }
  }

  colocaPreview(idIdioma:string,tipoIdioma:number){

      let objetoTextoAdicional = {};
      let numeroTextos = 0;
      if (tipoIdioma==0) {
        this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.forEach( (adicional) => {
          // console.log(adicional);
          if(adicional.idiomaId == idIdioma){
            adicional.preguntas.forEach(element => {
              if(adicional.idiomaId == idIdioma){
                  console.log('si coincide');
                if(element.tipoRespuesta == this.idAbierta){
                  objetoTextoAdicional = {
                    textoPregunta : element.traduccion,
                    tipoPregunta : element.tipoRespuesta,
                    idAdicional : element._id,
                    orden: element.orden
                  };
                  numeroTextos++;
                  this.totalTextosTraduccion++;
                }
                else if(element.tipoRespuesta == this.idSingle || element.tipoRespuesta == this.idMulti){
                          let textosOpciones: any[] = [];
                          element.opciones.forEach( (txtOpcion) => {
                            textosOpciones.push({textoOpcion: txtOpcion.traduccion, ordenOpcion: txtOpcion.orden});
                            numeroTextos++;
                            this.totalTextosTraduccion++;
                          });
                          objetoTextoAdicional = {
                            textoPregunta : element.traduccion,
                            tipoPregunta : element.tipoRespuesta,
                            opcionesResp : textosOpciones,
                            idAdicional : element._id,
                            orden: element.orden
                          };
                          numeroTextos++;
                          this.totalTextosTraduccion++;
                        }
                        this.textosPreguntasFiltrados.push(objetoTextoAdicional);
                        this.numeroTextosTraduccion.push(numeroTextos);


                        console.log(idIdioma,this.textosPreguntasFiltrados);
                      }
            });
          }
        });

      }else{
        console.log(tipoIdioma);

        this.preguntasAdicionalesFocus.preguntas.forEach(nativoIdioma => {
          if(nativoIdioma.tipoRespuesta == this.idAbierta){
            objetoTextoAdicional = {
              textoPregunta : nativoIdioma.pregunta,
              tipoPregunta : nativoIdioma.tipoRespuesta,
              idAdicional : nativoIdioma._id,
              orden: nativoIdioma.orden
            };
            numeroTextos++;
            this.totalTextosTraduccion++;
          }else if(nativoIdioma.tipoRespuesta == this.idSingle || nativoIdioma.tipoRespuesta == this.idMulti){
                    let textosOpciones: any[] = [];
                    nativoIdioma.opciones.forEach( (txtOpcion) => {
                      textosOpciones.push({textoOpcion: txtOpcion.respuesta});
                      numeroTextos++;
                      this.totalTextosTraduccion++;
                    });
                    objetoTextoAdicional = {
                      textoPregunta : nativoIdioma.pregunta,
                      tipoPregunta : nativoIdioma.tipoRespuesta,
                      opcionesResp : textosOpciones,
                      idAdicional : nativoIdioma._id,
                      orden: nativoIdioma.orden
                    };
                    numeroTextos++;
                    this.totalTextosTraduccion++;
                  }
                  this.textosPreguntasFiltrados.push(objetoTextoAdicional);
                  this.numeroTextosTraduccion.push(numeroTextos);

        });
      }


  }

  selIdiomaPreview(idLang:any){
    // console.log("idioma seleccionado: ");
    console.log(idLang);
    this.primeraSeleccion = true;
    this.textosPreguntasFiltrados = [];
    this.numeroTextosTraduccion = [];
    this.totalTextosTraduccion = 0;
    this.colocaPreview(idLang._id,idLang.tipoIdioma);
  }

}
